<template>
  <h2>タイムシート （就業場所・部課／月ごとの勤務一覧）</h2>
  <div class="container">
    <loading v-if="!isInit"></loading>
    <template v-else-if="syuugyouBasyoOptions.length > 0">
      <div class="kinmu-list-header flex">
        <div class="control">
          <div class="name">{{ kinmuListInfo.userName }}（社員番号：{{ kinmuListInfo.staffCode ? kinmuListInfo.staffCode : '-'
            }}）<span>さんの</span></div>
          <div class="flex selector-section">
            <div class="location">
              <select v-model="selectedSyuugyouBasyoOption" @change="changeSyuugyouBasyo" :disabled="isLoading">
                <option v-for="syuugyoubasyo in syuugyouBasyoOptions" :value="syuugyoubasyo"
                  :key="syuugyoubasyo.koyou_id"
                  :selected="selectedSyuugyouBasyoOption?.koyou_id === syuugyoubasyo.koyou_id">{{ syuugyoubasyo.label }}
                </option>
              </select>
            </div>

            <div class="period-selecter">
              <month-picker v-model="yearMonthForMonthPicker" @update:modelValue="changeMonth" :disabled="isLoading"
                :clearable=false></month-picker>
              <span>のタイムシートを表示中です</span>
            </div>

            <button class="btn primary" :disabled="!kintaiSummaryId" @click="allLoad()">再読み込み</button>
          </div>

          <div class="flex button-area">
            <template
              v-if="!isLoading && kintaiSummaryId && (isTimeSheetKakuteiUser || authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN))">
              <div v-if="!kintaiSummaryIsClosed">
                <button class="btn success" :disabled="!kintaiSummaryId"
                  @click="switchCloseKintaiSummary(true)">タイムシート確定（締め）</button>
              </div>

              <div v-if="kintaiSummaryIsClosed">
                <button class="btn warning"
                  :disabled="!kintaiSummaryId || !authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)"
                  @click="switchCloseKintaiSummary()">確定（締め）解除</button>
              </div>
            </template>

            <div v-if="authStore.hasPermission(PermissionConst.DAKOKU_IKKATSU_SYOUNIN)">
              <button class="btn info" v-on:click="toStaffList">スタッフを選択</button>
            </div>

            <div v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)">
              <button class="btn success" v-on:click="toSoumuCheck">総務確認へ移動する</button>
            </div>

            <div v-if="authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)">
              <button class="btn success" v-on:click="toTimeSheetKakuteiShime">タイムシート確定締へ移動する</button>
            </div>

            <div v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)
      && authStore.hasPermission(PermissionConst.CAN_ACCESS_HAKEN_SYAIN)">
              <button class="btn success" v-on:click="toHakensakiShimeCheck">派遣先締確認へ移動する</button>
            </div>
          </div>
        </div>

        <div class="syounin-info flex"
          v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) || authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)">
          <table class="syounin-user">
            <tr>
              <th class="thead" colspan="2">承認欄</th>
            </tr>
            <tr>
              <th>役職名</th>
              <td>{{ kintaiSummary?.syounin_user_yakusyoku ? kintaiSummary?.syounin_user_yakusyoku : "-" }}</td>
            </tr>
            <tr>
              <th>氏名</th>
              <td>{{ kintaiSummary?.syounin_user_name ? kintaiSummary?.syounin_user_name : "-" }}</td>
            </tr>
          </table>

          <table class="syounin-datetime">
            <tr>
              <th class="thead">承認日時</th>
            </tr>
            <tr>
              <td>
                <p class="align-center">{{ kintaiSummary?.syounin_datetime ? (dateFormat(kintaiSummary.syounin_datetime)
      +
      ' ' + timeFormat(kintaiSummary.syounin_datetime)) : "-" }}</p>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <h3>勤務一覧</h3>
      <div class="header-description">
        <p v-if="kinmuListData && kinmuListData.isAfterTaisyokuMonth" class="notice">退職後の月のため表示できません</p>
        <div v-else>出勤、外出、戻り、退勤が赤くなっている行は計算に必要な打刻が不足している行です。<br>
          <template v-if="isOther">打刻者による打刻を待つか打刻修正申請を提出してもらってください。</template>
          <template v-else>打刻をするか打刻修正申請を提出して赤い行を無くしてください。</template>
        </div>
        <div class="button-section" v-if="isAllowIkkatsuSyounin">
          <button class="btn info" v-on:click="recalcAll" v-if="!kintaiSummaryIsClosed && authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)">再計算の実行</button>
          <button class="btn info" v-on:click="setDakokuSyouninAll">承認にチェックを入れる</button>
          <button class="btn info" v-on:click="updateDakokuSyouninList"
            :disabled="selectItemCountSyounin === 0">一括承認</button>
        </div>
      </div>
      <loading v-if="isLoading"></loading>
      <section class="table-wrapper">
        <scroll-table v-if="!isLoading && kinmuListData && !kinmuListData.isAfterTaisyokuMonth" :height="'700px'">
          <table class="kinmu-table">
            <thead class="mob-table-head">
              <tr class="kinmu-table-header-row">
                <th rowspan="2" class="mob-date">日付</th>
                <th rowspan="2" class="mob-none dakoku-recalc"
                  v-if="Config.APP_DEBUG || authStore.hasPermission(PermissionConst.SYSTEM_ADMIN)">更新<br>（再計算）</th>
                <th rowspan="2" class="mob-none dakoku-syuusei" v-if="!isOther">打刻<br>修正</th>
                <th rowspan="2" class="mob-none dakoku-syuusei"
                  v-if="isOther && authStore.hasPermission(PermissionConst.KINMU_EDIT)">総務<br>修正</th>

                <th rowspan="2" class="mob-disp dakoku-syuusei" v-if="!isOther">修正</th>
                <th rowspan="2" class="mob-disp dakoku-syuusei"
                  v-if="isOther && authStore.hasPermission(PermissionConst.KINMU_EDIT)">修正</th>
                <th rowspan="2" class="mob-disp">詳細</th>

                <th rowspan="2" class="mob-none">出勤<br />（打刻時間）</th>
                <th rowspan="2" class="mob-disp mob-syukkin">出勤</th>

                <th rowspan="2" class="mob-none">外出<br />（打刻時間）</th>
                <th rowspan="2" class="mob-none">戻り<br />（打刻時間）</th>

                <th rowspan="2" class="mob-none">退勤<br />（打刻時間）</th>
                <th rowspan="2" class="mob-disp mob-taikin">退勤</th>

                <th rowspan="2" class="mob-none">休憩</th>
                <th rowspan="2" class="mob-none">所定労働<br />時間</th>
                <th rowspan="2" class="mob-none">控除時間</th>
                <th rowspan="2" class="mob-none">法定内残業</th>
                <th rowspan="2" class="mob-none">時間外</th>
                <th rowspan="2" class="mob-none">深夜割増</th>
                <th rowspan="2" class="mob-none">遅刻</th>
                <th rowspan="2" class="mob-none">早退</th>
                <!-- <th class="mob-none">本人コメント</th> -->
                <th class="medica-memo" v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)"
                  colspan="2">
                  メディカによる補正欄</th>
                <th class="medica-memo" v-else-if="authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)"
                  colspan="2">メディカによる補正欄</th>
                <th rowspan="2" class="mob-none approve">承認</th>
              </tr>

              <tr class="kinmu-table-header-row"
                v-if="authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)">
                <th class="medica-memo">メモ</th>
                <th class="medica-memo">時間<br>(単位：時)</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in kinmuListData.list">
                <template v-if="item.kinmus.length > 0">
                  <!-- <tr class="kinmu-table-data-row" :ref="(el: any) => { if (el) rows.push({ key: item.key, el: el }) }" -->
                  <tr class="kinmu-table-data-row" :class="{
      'is-approval': kinmu.syounin_status_type === OptionConst.DAKOKU_SYOUNIN_STATUS.APPROVED,
      'applying': item.waitShinseis.length > 0,
      'soumu-syuusei': kinmu.soumu_change_user_id,
      'uncomplete': kinmu.isUncomplete,
      'need-kyuukei': kinmu.isNeedKyuukei
    }" v-for="(kinmu, index) in item.kinmus" :key="kinmu.dakoku_id" @click="selectedDakoku(kinmu)">
                    <td class="date mob-none" v-if="index === 0" :rowspan="item.kinmus.length"
                      v-bind:class="{ 'color-red': item.date_for_display.substr(-2, 1) == '日' }">

                      {{ item.date_for_display }}

                      <shinseis-title :shinseis="item.shinseis" :kinmu="kinmu"
                        :year="kinmuListInfo.year != null ? kinmuListInfo.year : undefined"
                        :month="kinmuListInfo.month != null ? kinmuListInfo.month : undefined"></shinseis-title>

                    </td>

                    <!-- mobile -->
                    <td class="date mob-disp mob-date" v-if="index === 0" :rowspan="item.kinmus.length">
                      {{ item.date_for_display }}

                      <!-- icon -->
                      <!-- <div class="icon-container"> -->

                      <template v-if="kinmu.syounin_status_type === OptionConst.SYOUNIN_STATUS.WAIT">
                        <div class="icon" :class="{ 'disabled': !isAllowDakokuSyounin }"
                          v-on:click="openDakokuSyouninDialog(kinmu, item.key)">
                          <img :src="Const.SYOUNIN_STATUS_WAIT_ICON_PATH" />
                        </div>
                      </template>

                      <template v-if="kinmu.syounin_status_type === OptionConst.SYOUNIN_STATUS.APPROVED">
                        <div class="icon" :class="{ 'disabled': !isAllowDakokuSyounin }"
                          v-on:click="openDakokuSyouninDialog(kinmu, item.key)">
                          <img :src="Const.SYOUNIN_STATUS_APPROVED_ICON_PATH" />
                        </div>
                      </template>

                      <template v-if="kinmu.syounin_status_type === OptionConst.SYOUNIN_STATUS.DENIED">
                        <div class="icon" :class="{ 'disabled': !isAllowDakokuSyounin }"
                          v-on:click="openDakokuSyouninDialog(kinmu, item.key)">
                          <img :src="Const.SYOUNIN_STATUS_DENIED_ICON_PATH" />
                        </div>
                      </template>

                      <!-- </div> -->
                      <!-- icon -->

                      <template v-if="isAllowIkkatsuSyounin">
                        <input-checkbox :options="OptionConst.NO_LABEL" v-model="item.is_syounin_select"
                          :disabled="!isEnableCheckBox(kinmu)"></input-checkbox>
                      </template>

                      <shinseis-title :shinseis="item.shinseis" :kinmu="kinmu"
                        :year="kinmuListInfo.year != null ? kinmuListInfo.year : undefined"
                        :month="kinmuListInfo.month != null ? kinmuListInfo.month : undefined"></shinseis-title>

                    </td>
                    <!-- mobile -->

                    <!-- 再計算ボタン列（デバッグ用） -->
                    <td class="recalc mob-none"
                      v-if="Config.APP_DEBUG || authStore.hasPermission(PermissionConst.SYSTEM_ADMIN)">
                      <p v-if="kintaiSummaryIsClosed">-</p>
                      <i v-else class="fas fa-history" v-on:click="recalcByInfo(item)"></i>
                    </td>

                    <!-- 総務修正列（総務限定） -->
                    <td class="shinsei mob-syuusei-btn"
                      v-if="isOther && authStore.hasPermission(PermissionConst.KINMU_EDIT)">
                      <p v-if="kintaiSummaryIsClosed">-</p>
                      <i v-else class="fa-solid fa-pen"
                        v-on:click="openSoumuSyuuseiDialog(kinmu, item.datetime.toLocaleString(), item.shinseis)"></i>
                    </td>

                    <!-- 打刻修正列（総務外限定） -->
                    <td class="shinsei mob-syuusei-btn" v-if="!isOther">
                      <p v-if="kinmu.syounin_status_type == OptionConst.DAKOKU_SYOUNIN_STATUS.APPROVED">-</p>
                      <i v-else class="fa-solid fa-inbox"
                        v-on:click="openDakokuSyuuseiDialog(item.key, kinmu, item.hayaban_osoban, item.shinseis)"></i>
                    </td>

                    <!-- 打刻詳細表示ボタン（スマホ限定）-->
                    <td class="mob-disp mob-detail-btn">
                      <i class="fa-solid fa-square-caret-down"
                        v-on:click="openDakokuDetailDialog(kinmu, item.datetime.toLocaleString(), item.shinseis)"></i>
                    </td>

                    <td class="syukkin mob-syukkin">
                      {{ timeFormat(kinmu.syukkin_round_datetime) }}
                      <span v-if="kinmu.syukkin_round_datetime"><br />
                        ({{ timeFormat(kinmu.syukkin_datetime) }})
                      </span>
                    </td>
                    <td class="gaisyutsu mob-none">
                      {{ timeFormat(kinmu.gaisyutsu_round_datetime) }}
                      <span v-if="kinmu.gaisyutsu_round_datetime"><br />
                        ({{ timeFormat(kinmu.gaisyutsu_datetime) }})
                      </span>
                    </td>
                    <td class="modori mob-none">
                      {{ timeFormat(kinmu.modori_round_datetime) }}
                      <span v-if="kinmu.modori_round_datetime"><br />
                        ({{ timeFormat(kinmu.modori_datetime) }})
                      </span>
                    </td>
                    <td class="taikin mob-taikin">
                      {{ timeFormat(kinmu.taikin_round_datetime) }}
                      <span v-if="kinmu.taikin_datetime"><br />
                        ({{ timeFormat(kinmu.taikin_datetime) }})
                      </span>
                    </td>
                    <td class="kyuukei mob-none">
                      {{ timeToHHmm(kinmu.kyuukei_round_times) }}
                      <span v-if="kinmu.kyuukei_times"><br />
                        ({{ timeToHHmm(kinmu.kyuukei_times) }})
                      </span>
                    </td>
                    <td class="syotei-work-time mob-none">
                      {{ kinmu.syotei_work_times ? timeToHHmm(kinmu.syotei_work_times) : '00:00' }}
                    </td>
                    <td class="koujo-time mob-none">
                      {{ kinmu.koujo_times ? timeToHHmm(kinmu.koujo_times) : '00:00' }}
                    </td>
                    <td class="houteinai-work-time mob-none">
                      {{ kinmu.houteinai_zangyou_times ? timeToHHmm(kinmu.houteinai_zangyou_times) : '00:00' }}
                    </td>
                    <td class="jikangai-work-time mob-none">
                      {{ kinmu.jikangai_work_times ? timeToHHmm(kinmu.jikangai_work_times) : '00:00' }}
                    </td>
                    <td class="shinya-warimashi-times mob-none">
                      {{ kinmu.shinya_warimashi_times ? timeToHHmm(kinmu.shinya_warimashi_times) : '00:00' }}
                    </td>
                    <td class="chikoku-time mob-none">
                      {{ kinmu.chikoku_times ? timeToHHmm(kinmu.chikoku_times) : '00:00' }}
                    </td>
                    <td class="soutai-time mob-none">
                      {{ kinmu.soutai_times ? timeToHHmm(kinmu.soutai_times) : '00:00' }}
                    </td>
                    <!-- <td class="honnin-notes mob-none">
                    <div class="pre">{{ kinmu.honnin_notes }}</div>
                    <p @click="openHonninNotesModal(kinmu)" class="link-text"
                      v-if="!isOther && kinmu.syounin_status_type !== OptionConst.DAKOKU_SYOUNIN_STATUS.APPROVED">
                      <template v-if=kinmu.honnin_notes>編集</template>
                      <template v-else>登録</template>
                    </p>
                  </td> -->

                    <td class="medica-memo view"
                      v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) || authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)">
                      <p>{{ kinmu.soumu_note1 }}</p>

                      <template v-if="kinmu.yuukyuu_times">
                        有給{{ kinmu.yuukyuu_times }}
                      </template>
                    </td>

                    <td class="medica-memo view"
                      v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) || authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)">
                      <p>{{ kinmu.soumu_note2 }}</p>
                    </td>

                    <td class="approve mob-none">
                      <template v-if="kinmu.syounin_status_type === OptionConst.SYOUNIN_STATUS.WAIT">
                        <div class="icon" :class="{ 'disabled': !isAllowDakokuSyounin }"
                          v-on:click="openDakokuSyouninDialog(kinmu, item.key)">
                          <img :src="Const.SYOUNIN_STATUS_WAIT_ICON_PATH" />
                        </div>
                      </template>

                      <template v-if="kinmu.syounin_status_type === OptionConst.SYOUNIN_STATUS.APPROVED">
                        <div class="icon" :class="{ 'disabled': !isAllowDakokuSyounin }"
                          v-on:click="openDakokuSyouninDialog(kinmu, item.key)">
                          <img :src="Const.SYOUNIN_STATUS_APPROVED_ICON_PATH" />
                        </div>
                      </template>

                      <template v-if="kinmu.syounin_status_type === OptionConst.SYOUNIN_STATUS.DENIED">
                        <div class="icon" :class="{ 'disabled': !isAllowDakokuSyounin }"
                          v-on:click="openDakokuSyouninDialog(kinmu, item.key)">
                          <img :src="Const.SYOUNIN_STATUS_DENIED_ICON_PATH" />
                        </div>
                      </template>

                      <template v-if="isAllowIkkatsuSyounin">
                        <input-checkbox :options="OptionConst.NO_LABEL" v-model="item.is_syounin_select"
                          :disabled="!isEnableCheckBox(kinmu)"></input-checkbox>
                      </template>
                    </td>
                  </tr>
                </template>

                <template v-if="item.kinmus.length <= 0">
                  <!-- <tr class="none" :class="{ applying: item.waitShinseis.length > 0 }"
                  :ref="(el: any) => { if (el) rows.push({ key: item.key, el: el }) }" @click="selectedDakoku(null)"> -->
                  <tr class="none" :class="{ applying: item.waitShinseis.length > 0 }" :key="item.key">
                    <td class="date mob-date"
                      v-bind:class="{ 'color-red': item.date_for_display.substr(-2, 1) == '日' }">
                      {{ item.date_for_display }}

                      <shinseis-title :shinseis="item.shinseis" :kinmu="null"
                        :year="kinmuListInfo.year != null ? kinmuListInfo.year : undefined"
                        :month="kinmuListInfo.month != null ? kinmuListInfo.month : undefined"></shinseis-title>

                    </td>
                    <td class="shinsei mob-syuusei-btn" v-if="!isOther">
                      <p v-if="kintaiSummaryIsClosed">-</p>
                      <i v-else class="fa-solid fa-inbox"
                        v-on:click="openDakokuSyuuseiDialog(item.key, null, item.hayaban_osoban, item.shinseis)"></i>
                    </td>
                    <td class="shinsei mob-syuusei-btn"
                      v-if="isOther && authStore.hasPermission(PermissionConst.KINMU_EDIT)">
                      <p v-if="kintaiSummaryIsClosed">-</p>
                      <i v-else class="fa-solid fa-pen"
                        v-on:click="openSoumuSyuuseiDialog(null, item.datetime.toLocaleString(), item.shinseis)"></i>
                    </td>
                    <td class="mob-disp mob-detail-btn">
                    </td>
                    <td class="syukkin mob-syukkin"></td>
                    <td class="gaisyutsu mob-none"></td>
                    <td class="modori mob-none"></td>
                    <td class="taikin mob-taikin"></td>
                    <td class="kyuukei mob-none"></td>
                    <td class="chikoku-time mob-none"></td>
                    <td class="soutai-time mob-none"></td>
                    <td class="koujo-time mob-none"></td>
                    <td class="syotei-work-time mob-none"></td>
                    <td class="houteinai-work-time mob-none"></td>
                    <td class="jikangai-work-time mob-none"></td>
                    <td class="shinya-warimashi-times mob-none"></td>
                    <!-- <td class="honnin-notes mob-none"></td> -->
                    <td class="medica-memo"
                      v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) || authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)">
                    </td>
                    <td class="medica-memo"
                      v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) || authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)">
                    </td>
                    <td class="approve mob-none">-</td>
                  </tr>
                </template>
              </template>

              <tr class="kinmu-table-data-row"
                v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) || authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)">
                <td>計</td> <!-- 日付列 -->
                <td v-if="Config.APP_DEBUG"></td> <!-- 再計算列／デバッグ用 -->
                <td class="mob-syuusei-btn" v-if="authStore.hasPermission(PermissionConst.KINMU_EDIT)"></td>
                <!-- 総務修正／打刻修正列 -->
                <td></td> <!-- 出勤列 -->
                <td class="mob-none"></td> <!-- 外出列 -->
                <td class="mob-none"></td> <!-- 戻り列 -->
                <td></td> <!-- 退勤列 -->
                <td class="mob-none"></td> <!-- 休憩列 -->
                <td class="mob-none">{{ sumKinmuTime }}</td> <!-- 所定労働時間列 -->
                <td class="mob-none"></td> <!-- 控除時間列 -->
                <td class="mob-none"></td> <!-- 法定内残業列 -->
                <td class="mob-none"></td> <!-- 時間外列 -->
                <td class="mob-none"></td> <!-- 時間外（深夜）列 -->
                <td class="mob-none"></td> <!-- 遅刻列 -->
                <td class="mob-none"></td> <!-- 早退列 -->
                <td class="medica-memo view"
                  :class="{ view: !authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) }"></td> <!-- 補正欄１列 -->
                <td class="medica-memo view"
                  :class="{ view: !authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) }">
                  {{ allSoumuModifyTime }}
                </td> <!-- 補正欄２列 -->
                <td class="approve mob-none"></td> <!-- 承認列 -->
              </tr>
            </tbody>
          </table>
        </scroll-table>
      </section>
      <p v-if="!isLoading && !kinmuListData">表示できる内容がありません</p>
    </template>

    <p v-else class="aligncenter">表示できるタイムシートがありません</p>
    <modal :title="dakokuSyuuseiModalParts.title" ref="dakokuSyuuseiModalRef">
      <dialog-dakoku-syuusei :syuuseiData="syuuseiData" :koyouKeiyakuId="selectedSyuugyouBasyoOption?.koyou_id"
        :syuugyouBasyoId="selectedSyuugyouBasyoOption?.val" @send="sendDakokuSyuusei" @cancel="canceldDakokuSyuusei"
        :hayabanOsobanData="hayabanOsobanData" :shinseiData="shinseiData" @load="allLoad">
      </dialog-dakoku-syuusei>
    </modal>

    <modal :title="dakokuSyouninModalParts.title" ref="dakokuSyouninModalRef">
      <dialog-dakoku-syounin :syouninData="syouninData" :canSyounin="canSyounin" @send="sendDakokuSyounin"
        @cancel="canceldDakokuSyounin">
      </dialog-dakoku-syounin>
    </modal>

    <modal :title="dakokuDetailModalParts.title" ref="dakokuDetailModalRef">
      <dialog-dakoku-detail :detailData="detailData" :syouninStr="dakokuSyouninStatus(detailData.syounin_status_type)"
        :hayabanOsobanData="hayabanOsobanData" :shinseis="shinseis" @close="closeDakokuDetailDialog"
        @openHonninNotesModal="openHonninNotesModal">
      </dialog-dakoku-detail>
    </modal>
    <!--
    <modal ref="honninNotesInputModalRef" :title="honninNotesInputModalParts.title">
      <honnin-notes-input :notes="selectedDakokuData?.honnin_notes" :syuugyouBasyoId="selectedSyuugyouBasyoOption?.val"
        :koyouKeiyakuId="selectedSyuugyouBasyoOption?.koyou_id" :targetDate="selectedDakokuData?.dakoku_date"
        :koyouKeiyakuTimeId="selectedDakokuData?.koyou_keiyaku_time_id" v-on:send="honninNotesInputSend()"
        v-on:cancel="honninNotesInputCancel()">
      </honnin-notes-input>
    </modal> -->

    <modal ref="soumuSyuuseiModalRef" :title="soumuSyuuseiModalParts.title" :width="'1000px'">
      <soumu-syuusei :syuuseiData="soumuSyuuseiData" :koyouKeiyakuId="selectedSyuugyouBasyoOption?.koyou_id"
        :syuugyouBasyoId="selectedSyuugyouBasyoOption?.val"
        :koyouKeiyakuTimeId="selectedDakokuData?.koyou_keiyaku_time_id" @close="closeSoumuSyuuseiDialog"
        @send="sendSoumuSyuuseiDialog">
      </soumu-syuusei>
    </modal>

    <!-- MEDICA_AS-1090 対応 ここから -->
    <h3>勤怠サマリー（集計結果）</h3>
    <div class="summary-section">
      <kinmu-summary :syuugyouBasyoId="selectedSyuugyouBasyoOption?.val" :userId="kinmuListInfo.userId"
        :koyouKeiyakuId="selectedSyuugyouBasyoOption?.koyou_id"
        :year="kinmuListInfo.year != null ? kinmuListInfo.year : undefined"
        :month="kinmuListInfo.month != null ? kinmuListInfo.month : undefined" v-on:loaded="setKintaiSummaryId"
        :execLoad="reloadSummary"></kinmu-summary>
    </div>
    <!-- MEDICA_AS-1090 対応 ここまで -->

    <div class="sub-info">
      <div class="syozoku">
        <p>所属会社：{{ kinmuListInfo.syozokuInfo?.syozoku_name }}</p>
      </div>

      <div class="meijisyo" v-if="kinmuListInfo.syozokuInfo?.mst_syozoku_id === OptionConst.SYOZOKU.PG">
        <p class="syuugyou-basyo-name">就業場所：{{ kinmuListInfo.meijisyoInfo?.syuugyou_basyo_name }}</p>
        <p class="soshiki-tanni">組織単位：
          {{ kinmuListInfo.meijisyoInfo?.soshiki_tanni ? kinmuListInfo.meijisyoInfo?.soshiki_tanni : '-' }}</p>
        <p class="work-detail">業務内容：
          <template v-if="kinmuListInfo.meijisyoInfo?.work_detail1 || kinmuListInfo.meijisyoInfo?.work_detail2">
            {{ kinmuListInfo.meijisyoInfo?.work_detail1 }}
            <span v-if="kinmuListInfo.meijisyoInfo?.work_detail2">
              （{{ kinmuListInfo.meijisyoInfo?.work_detail2 }}）
            </span>
          </template>
          <template v-else>-</template>
        </p>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { useKinmuList } from "@/composable/kinmu/list";
import { computed, defineComponent, onMounted, Ref, ref } from "vue";
import { dateFormat, dateFormatJp, timeFormat, timeToHHmm } from "@/filters/common";
import DakokuSyuusei from "@/components/dakoku/DakokuSyuusei.vue"
import DakokuSyounin from "@/components/dakoku/DakokuSyounin.vue"
import DakokuDetail from "@/components/dakoku/DakokuDetail.vue";
import { useDakokuSyuuseiModal } from '@/composable/modal/dakoku-syuusei'
import { useDakokuSyouninModal } from '@/composable/modal/dakoku-syounin'
import { useDakokuDetailModal } from '@/composable/modal/dakoku-detail';
import { useKintaiSummary } from '@/composable/kinmu/summary'
import { DakokuDataFull, DakokuInfoShinsei, HakenDakokuData, KinmuListData, KintaiSummaryData, RecalcDakokByDakokuInfo, ShinseiInfo } from "@/types/Dakoku";
import KinmuSummary from '@/components/kinmu/Summary.vue'
import OptionConst from "@/const/Option";
import { useSyuugyouBasyoInit } from "@/composable/syuubyoubasyo/init";
import { MonthPickerModelValue } from "../form/MonthPicker.vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/store/auth";
import { PermissionConst } from "@/const/Permission";
import { useRouter } from 'vue-router';
import { RouterConst } from "@/const/Router";
import { useInit as useSyouninGroupInit } from "@/composable/master/syounin_group/init";
import { useHonninNotesInputModal } from "@/composable/modal/honnin-notes-input"
import HonninNotesInput from '@/components/dakoku/HonninNotes.vue'
import Const from '@/const/Shinsei/Option';
import { DialogService } from "@/service/DialogService";
import { HayabanOsoban } from "@/types/Shinsei";
import ShinseisTitle from '@/components/kinmu/ShinseisTitle.vue';
import SoumuSyuusei from "@/components/dakoku/SoumuSyuusei.vue";
import { useSoumuSyuuseiModal } from "@/composable/modal/soumu-syuusei";
import Config from "@/const/Config";
import Message from "@/const/Message";
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { cloneDeep } from "lodash";
import { useDakoku } from "@/composable/dakoku/dakoku";
import { ConvertUtil } from "@/utils/ConvertUtil";
import { useMyTaskCommonStore } from '@/store/mytask-common';
import { SyuugyouBasyoOption } from "@/types/SyuugyouBasyo";
import { DateUtil } from "@/utils/DateUtil";

export default defineComponent({
  setup() {
    const { syuugyouBasyoOptions, getOptionsByDakokuAndKoyouKeiyaku, selectedSyuugyouBasyoOption } = useSyuugyouBasyoInit()
    const { getKinmuList, loadKinmuList, kinmuListData, kinmuListInfo, sumKinmuTime, dakokuSyouninStatus, getKinmuListInfoByDakokuId, ikkatsuSyounin, kinmuListSelectSyouninData } = useKinmuList()
    const { closeKintaiSummary, closeCancelKintaiSummary, getKintaiSummary, kintaiSummary } = useKintaiSummary()
    const { hasPermissionForTargetUser, isSyouninUser, isKakuninUser, groupsWithPermission } = useSyouninGroupInit()
    const { recalcDakokuByDakokuInfos } = useDakoku()
    const dakokuSyuuseiModal = useDakokuSyuuseiModal()
    const dakokuSyouninModal = useDakokuSyouninModal()
    const dakokuDetailModal = useDakokuDetailModal()
    const soumuSyuuseiModal = useSoumuSyuuseiModal()
    const router = useRouter()
    const route = useRoute()
    const authStore = useAuthStore()
    const kintaiSummaryId: Ref<number | null> = ref(null)
    const kintaiSummaryIsClosed = ref(false)
    const reloadSummary = ref(false)
    const rows: Ref<{ key: string, el: HTMLTableRowElement }[]> = ref([])
    const selectRowKey: Ref<string | number | null> = ref(null)

    const selectedDakokuData: Ref<DakokuDataFull | null> = ref(null)
    const honninNotesInputModal = useHonninNotesInputModal()

    const isInit = ref(false)
    const isLoading = ref(false)
    dayjs.extend(isSameOrAfter);

    const myTaskCommonStore = useMyTaskCommonStore()

    const isTimeSheetKakuteiUser = ref(false)
    const isAllowIkkatsuSyounin = ref(false)
    const canSyounin = ref(false)

    onMounted(async () => {
      // URLから抽出条件を取得
      const targetDakokuId = route.query.dakoku_id ? parseInt(route.query.dakoku_id as string, 10) : null
      const targetSyouninGroupId = route.query.targetSyouninGroupId ? parseInt(route.query.targetSyouninGroupId as string, 10) : null;

      let targetUserId: number | null = route.query.targetUserId ? parseInt(route.query.targetUserId as string, 10) : null
      let targetYear = route.query.year ? parseInt(route.query.year as string, 10) : null
      let targetMonth = route.query.month ? parseInt(route.query.month as string, 10) : null
      let targetSyuugyouBasyoId = route.query.mst_syuugyou_basyo_id ? parseInt(route.query.mst_syuugyou_basyo_id as string, 10) : null
      let targetKoyouKeiyakuId = route.query.koyou_keiyaku_id ? parseInt(route.query.koyou_keiyaku_id as string, 10) : null

      let getByPeriodArg = true

      /** ----パラメーターや権限による画面表示可否の決定ブロックここから---- */
      if (!authStore.user) {
        await DialogService.error({
          html: 'ログイン中のユーザー情報取得に失敗しました。<br>再ログインを実行してください'
        })
        location.href = Config.LOGOUT_URL
        return
      }

      if (route.query.from === RouterConst.MY_TASK) {
        // 遷移元がマイタスクの場合
        // 対象ユーザIDチェック
        if (targetUserId === null) {
          await DialogService.error({
            html: '表示対象のユーザーID取得に失敗しました。<br>前画面より再度選択してください。'
          }, true)

          if (authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)) {
            await toSoumuCheck()
          } else {
            await toStaffList()
          }
          return
        }

        // 総務以外のユーザーにおける各種チェック
        if (!authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)) {
          if (targetSyouninGroupId === null) {
            // 承認グループIDの指定が無い場合
            await DialogService.error({
              html: '表示対象の承認グループ情報の失敗しました。<br>前画面より再度選択してください。'
            }, true)
            await toStaffList()
            return
          }

          // 承認グループとその権限を取得
          await hasPermissionForTargetUser(targetUserId!);
          // 取得した「承認グループとその権限」から対象の打刻承認グループを取り出す
          let targetSyouninGroup = groupsWithPermission.value.filter((v) => {
            return v.mstSyouninGroupId === targetSyouninGroupId
          }
          );

          // 打刻承認グループに権限なしの場合
          if (targetSyouninGroup.length < 0) {
            await DialogService.error({
              html: '対象のユーザーに対する閲覧権限がありません。<br>前画面に戻ります。'
            }, true)
            await toStaffList()
            return;
          }
        }
      }
      /** ----パラメーターや権限による画面表示可否の決定ブロックここまで---- */

      if (targetDakokuId) {
        // 打刻IDが指定されている場合は打刻IDから勤務一覧に必要な情報(kinmuListInfo)を取得する
        // なお、他人のタイムシートを見る場合、この段階で権限チェックが行われている
        await getKinmuListInfoByDakokuId(targetDakokuId)

        // URLで渡されていたとしても打刻IDから導出された情報を正とする
        targetYear = kinmuListInfo.value.year
        targetMonth = kinmuListInfo.value.month
        targetSyuugyouBasyoId = kinmuListInfo.value.syuugyouBasyo?.val ? kinmuListInfo.value.syuugyouBasyo?.val : null
        targetKoyouKeiyakuId = kinmuListInfo.value.syuugyouBasyo?.koyou_id ? kinmuListInfo.value.syuugyouBasyo?.koyou_id : null
        targetUserId = kinmuListInfo.value.userId

        // 就業場所一覧の取得と初期値の設定
        await getOptionsByDakokuAndKoyouKeiyaku(targetUserId, targetYear, targetMonth, true)
        if (targetUserId === authStore.user.user_id || authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)) {
          // 自身のタイムシートを閲覧する場合または総務による閲覧の場合、打刻IDから導出された就業場所を選択する
          if (syuugyouBasyoOptions.value.length > 0) {
            const matchedSyuugyouBasyo = syuugyouBasyoOptions.value.find((syuugyouBasyo) => {
              return syuugyouBasyo.val === targetSyuugyouBasyoId && syuugyouBasyo.koyou_id === targetKoyouKeiyakuId
            })

            // 就業場所IDが指定されている場合は就業場所IDと雇用契約IDから選択し、一致するものが無い場合は最初の要素を選択する
            selectedSyuugyouBasyoOption.value = matchedSyuugyouBasyo ? matchedSyuugyouBasyo : syuugyouBasyoOptions.value[0]
          }
        } else {
          // 総務以外が他人のタイムシートを閲覧する場合、kinmuListInfoに含まれる就業場所オブジェクトをオプション配列にセットする
          // また、一時的にすべての就業場所を取得するが前述の就業場所のみを選択可とする
          // 基本的にこのルートは上長が部下のタイムシートをチェックしたり総務がマイタスク経由でチェックする場合のルートであり、
          // 遷移してくる段階で確実にアクセスできる打刻IDのみを対象とする（基本的に就業場所へのアクセス権限を判定する基準がシステム上存在しないため）
          syuugyouBasyoOptions.value = []
          syuugyouBasyoOptions.value.push(kinmuListInfo.value.syuugyouBasyo!)
          selectedSyuugyouBasyoOption.value = kinmuListInfo.value.syuugyouBasyo
        }

        await getByPeriod(targetDakokuId)
      } else {
        // 打刻IDが指定されていない場合
        // 勤務一覧に必要な情報(kinmuListInfo)の取得が出来ないので、
        // ここまでにURL等で受け取っている情報から記事的に構成する
        kinmuListInfo.value.userId = targetUserId ? targetUserId : authStore.user.user_id

        await getOptionsByDakokuAndKoyouKeiyaku(targetUserId, targetYear, targetMonth, true)
        if (syuugyouBasyoOptions.value.length > 0) {
          if (targetSyuugyouBasyoId) {
            // 就業場所IDが指定されている場合は就業場所IDと雇用契約IDから選択する
            const matchedSyuugyouBasyo = syuugyouBasyoOptions.value.find((syuugyouBasyo) => {
              return syuugyouBasyo.val === targetSyuugyouBasyoId && syuugyouBasyo.koyou_id === targetKoyouKeiyakuId
            })
            selectedSyuugyouBasyoOption.value = matchedSyuugyouBasyo ? matchedSyuugyouBasyo : syuugyouBasyoOptions.value[0]
          } else {
            // 就業場所IDが指定されていない場合は最初の要素を選択する
            selectedSyuugyouBasyoOption.value = syuugyouBasyoOptions.value[0]
          }
          kinmuListInfo.value.syuugyouBasyo = selectedSyuugyouBasyoOption.value
        }

        if (targetYear && targetMonth) {
          kinmuListInfo.value.year = targetYear
          kinmuListInfo.value.month = targetMonth
        }

        await getByPeriod()
      }

      // ここまでにkinmuListInfoの内容はサーバーから受け取った内容で上書きされている
      // ※getByPeriodから呼ばれているloadKinmuListにて上書きしている

      loadSummary()
      await setEnableTimeSheetKakuteiStatus()

      if (kinmuListInfo.value.dakokuSyouninGroupId) {
        if (await isKakuninUser(kinmuListInfo.value.dakokuSyouninGroupId, authStore.user?.user_id)) {
          isAllowIkkatsuSyounin.value = false
          canSyounin.value = false
        } else {
          canSyounin.value = true
          isAllowIkkatsuSyounin.value = (authStore.hasPermission(PermissionConst.DAKOKU_IKKATSU_SYOUNIN)
            || authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)
            || authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI))
            && !kintaiSummaryIsClosed.value
        }
      } else {
        canSyounin.value = false
        isAllowIkkatsuSyounin.value = false
      }

      isInit.value = true
    })

    // 指定された就業場所の指定年月の勤務一覧を取得
    const getByPeriod = async (refDakokuId: number | null = null) => {
      if (!selectedSyuugyouBasyoOption.value || !kinmuListInfo.value.userId) {
        return
      }

      if (!kinmuListInfo.value.year || !kinmuListInfo.value.month) {
        // 年月情報を持っていない場合（初回など）
        await loadKinmuList(null, null, selectedSyuugyouBasyoOption.value.val, selectedSyuugyouBasyoOption.value.koyou_id, kinmuListInfo.value.userId, refDakokuId)
      } else {
        // 年月情報を持っている場合（打刻IDやURL文字列から年月が特定できている場合）
        await loadKinmuList(kinmuListInfo.value.year, kinmuListInfo.value.month, selectedSyuugyouBasyoOption.value.val, selectedSyuugyouBasyoOption.value.koyou_id, kinmuListInfo.value.userId, refDakokuId)
      }
      rows.value = []

      await calcProc()

      if (kinmuListInfo.value.year && kinmuListInfo.value.month) {
        // 年月が正しく設定されている場合のみサマリーを取得する
        // ※kinmuListInfo.valueのyearとmonthは初期値はnullだがloadKinmuList内でそれぞれnullで無くなっているため、
        // 　この段階でもnullという状況はそもそも正常ではないので両方セットされている場合のみリクエストを送る
        //   どちらかnullのまま送ってしまうとサーバー側でエラーとなる恐れがある
        await getKintaiSummary(kinmuListInfo.value.year, kinmuListInfo.value.month, selectedSyuugyouBasyoOption.value.val, selectedSyuugyouBasyoOption.value.koyou_id, kinmuListInfo.value.userId)
      } else {
        // ↑のとおり基本的に年月はセットされている想定なので何らかの理由で正しくセットされていない場合やり直してもらう
        DialogService.error({
          html: '年月が正しく設定されていないためサマリーを取得できません。<br>前の画面からやり直してください。'
        })
      }
    };

    // MonthPickerで年月を決定した際に実行
    const changeMonth = async (val: MonthPickerModelValue) => {
      kinmuListInfo.value.month = val.month + 1 // プログラム上の月番号と表示上の月名の補正
      kinmuListInfo.value.year = val.year

      // MEDICA_AS-920、MEDICA_AS-1112 対応
      // 選択された年月に含まれる雇用契約の就業場所オプションを取得し、セレクトボックスに設定する
      let targetUserId = null;
      // 自身のタイムシートを閲覧する場合
      if (kinmuListInfo.value.userId === authStore.user?.user_id) {
        targetUserId = authStore.user?.user_id;
      } else {
        // 承認者や総務等、自身以外がタイムシートを閲覧する場合
        targetUserId = route.query.targetUserId ? parseInt(route.query.targetUserId as string, 10) : null;
      }

      // セレクトボックスオプションを取得
      await getOptionsByDakokuAndKoyouKeiyaku(targetUserId, kinmuListInfo.value.year, kinmuListInfo.value.month, true)

      const syuugyouBasyoId = selectedSyuugyouBasyoOption.value?.val
      const idx = syuugyouBasyoOptions.value.findIndex((v) => { return v.val == syuugyouBasyoId })
      if (idx > 0) {
        selectedSyuugyouBasyoOption.value = syuugyouBasyoOptions.value[idx]
      } else {
        selectedSyuugyouBasyoOption.value = syuugyouBasyoOptions.value[0]
      }


      await getByPeriod()
      loadSummary()


      // if (kinmuListInfo.value.userId === authStore.user?.user_id) {
      //  await getOptionsByDakokuAndKoyouKeiyaku(authStore.user?.user_id, kinmuListInfo.value.year, kinmuListInfo.value.month, true)

      // ----TODO: しばらく運用してみて問題なければ削除----
      // 選択肢が変わった場合に初期値として最初の要素を選択する処理だが、
      // 基本的にシステム日にを基準に就業場所を取得するので初回以降は年月を変えても選択肢が変わることがないため不要と思われる
      //const syuugyouBasyoId = selectedSyuugyouBasyoOption.value?.val
      //const idx = syuugyouBasyoOptions.value.findIndex((v) => { return v.val == syuugyouBasyoId })
      // if (idx > 0) {
      //   selectedSyuugyouBasyoOption.value = syuugyouBasyoOptions.value[idx]
      // } else {
      //   selectedSyuugyouBasyoOption.value = syuugyouBasyoOptions.value[0]
      // }
      // ----削除対象ここまで----
      // }
    };

    // MonthPickerに渡すための年月obj
    const yearMonthForMonthPicker = computed((): MonthPickerModelValue => {
      return {
        year: kinmuListInfo.value.year as number,
        month: (kinmuListInfo.value.month as number) - 1 // プログラム上の月番号と表示上の月名の補正
      }
    })

    // 打刻修正ダイアログ
    const openDakokuSyuuseiDialog = async (
      dateKey: string,
      kinmu: DakokuDataFull | null = null,
      hayabanOsoban: HayabanOsoban | null = null,
      shisneis: DakokuInfoShinsei | null = null,
    ) => {
      if (dakokuSyuuseiModal.hasFlow()) {
        return
      }
      selectRowKey.value = dateKey

      console.log('selectRowKey.value', selectRowKey.value)
      const key = dateKey.split('-')
      const date = key[1] + '/' + key[2] + '/' + key[3]
      console.log('openDakokuSyuusei', kinmu)
      await dakokuSyuuseiModal.setShinseisData(shisneis, date)
      await dakokuSyuuseiModal.setData(kinmu, date)
      await dakokuSyuuseiModal.setHayabanOsobanData(hayabanOsoban)
      dakokuSyuuseiModal.openDakokuSyuuseiModal()
    }

    // 打刻修正の実行（申請提出）
    const sendDakokuSyuusei = async (result: boolean) => {
      await dakokuSyuuseiModal.clearData()
      dakokuSyuuseiModal.closeDakokuSyuuseiModal()
      await allLoad()
    }

    // 打刻修正ダイアログのクローズ
    const canceldDakokuSyuusei = async () => {
      console.log('closedDakokuSyuusei@parent')
      dakokuSyuuseiModal.closeDakokuSyuuseiModal()
      await dakokuSyuuseiModal.clearData()
    }

    const allLoad = async () => {
      isLoading.value = true;
      await getByPeriod()
      loadSummary()
      isLoading.value = false;
    }

    const isAllowDakokuSyounin = computed(() => {
      return authStore.hasPermission(PermissionConst.DAKOKU_SYOUNIN) && !kintaiSummaryIsClosed.value
    })

    // 打刻承認ダイアログ
    const openDakokuSyouninDialog = async (kinmu: DakokuDataFull, itemKey: string) => {
      if (!kinmu) {
        return
      }
      if (!isAllowDakokuSyounin.value) {
        return
      }
      // 今回の適用前に既に承認済み、否認済みのものを再承認・否認できるように対応
      if (kinmu.isUncomplete && kinmu.syounin_status_type === OptionConst.SYOUNIN_STATUS.WAIT) {
        return
      }

      await reloadShinseiData(kinmu.dakoku_id)

      const listItem = kinmuListData.value?.list.find((v: any) => v.key == itemKey)
      if (listItem && listItem.waitShinseis.length > 0) {
        const waitingShinsei = ConvertUtil.getShinseiLabel(listItem.waitShinseis)
        DialogService.warning({
          title: '未承認の申請があります',
          text: waitingShinsei + 'の承認を先に行ってください',
        })
        return
      }

      await dakokuSyouninModal.setData(kinmu)
      dakokuSyouninModal.openDakokuSyouninModal()
    }

    // 打刻承認の実行
    const sendDakokuSyounin = async (result: boolean, dakokuId: number, syouinStatus: number, comment: string) => {
      if (!kinmuListData.value) {
        return
      }

      await dakokuSyouninModal.clearData()
      dakokuSyouninModal.closeDakokuSyouninModal()

      if (!result) {
        DialogService.error({
          text: '予期せぬ事態が発生し承認に失敗しました'
        }, true);
        return;
      };

      // 承認ステータス更新
      let dakoku = kinmuListData.value.list.find((v) => {
        if (v.kinmus.length > 0 && v.kinmus[0].dakoku_id == dakokuId) {
          return true;
        }
      });
      if (dakoku) {
        dakoku.kinmus[0].syounin_status_type = syouinStatus;
        dakoku.kinmus[0].syounin_status_notes = comment;
      };

      let message = "承認しました";
      if (syouinStatus == OptionConst.SYOUNIN_STATUS.DENIED) {
        message = "否認しました";
      }

      DialogService.info({
        text: message
      }, true);
    }

    // 打刻承認ダイアログのクローズ
    const canceldDakokuSyounin = async () => {
      console.log('canceldDakokuSyounin@parent')
      dakokuSyouninModal.closeDakokuSyouninModal()
      await dakokuSyouninModal.clearData()
    }

    // 就業場所の変更
    const changeSyuugyouBasyo = async () => {
      // 選択されている就業場所の就業場所IDに合わせてURLを書き換える
      window.history.replaceState('', '', selectedSyuugyouBasyoOption.value?.val.toString())

      await getByPeriod()
      loadSummary()
      await setEnableTimeSheetKakuteiStatus()
    }

    // サマリーコンポーネントでサマリー取得が完了したらこのコンポーネントで受け取る（締め関連の操作のため）
    const setKintaiSummaryId = (summary: KintaiSummaryData | null) => {
      reloadSummary.value = false
      if (!summary) {
        kintaiSummaryId.value = null
        kintaiSummaryIsClosed.value = false
      } else {
        kintaiSummaryId.value = summary.kintai_summary_id;
        kintaiSummaryIsClosed.value = summary.syounin_status_type === OptionConst.SYOUNIN_STATUS.APPROVED ? true : false
      }
    }

    // 締め／解除の切り替え
    const switchCloseKintaiSummary = async (close = false) => {
      if (close) {
        if (kinmuListInfo.value.hasUncompleteDakoku) {
          await DialogService.error({
            title: '',
            text: Message.HAS_UNCOMPLETE_DAKOKU_ERROR
          })
          return
        }
        if (kinmuListInfo.value.hasWaitShinsei) {
          await DialogService.error({
            title: '',
            text: Message.HAS_WAIT_SHINSEI_ERROR
          })
          return
        }

        const result = await closeKintaiSummary(kintaiSummaryId.value, kinmuListInfo.value.dakokuSyouninGroupId)
        if (result) {
          // 状況反映のために就業場所を変更したことにして情報を再取得
          reloadSummary.value = true
          await getByPeriod()
          loadSummary()
        }
      } else {
        const result = await closeCancelKintaiSummary(kintaiSummaryId.value)
        if (result) {
          // 状況反映のために就業場所を変更したことにして情報を再取得
          await getByPeriod()
          loadSummary()
        }
      }
    }

    const loadSummary = () => {
      reloadSummary.value = true
    }

    const selectedDakoku = (dakokuData: DakokuDataFull | null) => {
      selectedDakokuData.value = dakokuData
    }

    const openHonninNotesModal = (dakokuData: DakokuDataFull) => {
      selectedDakoku(dakokuData)
      console.log(dakokuData)
      honninNotesInputModal.openHonninNotesInputModal()
    }
    const honninNotesInputSend = async () => {
      honninNotesInputModal.closeHonninNotesInputModal()
      dakokuDetailModal.closeDakokuDetailModal()
      await getByPeriod()
    }

    const honninNotesInputCancel = async () => {
      honninNotesInputModal.closeHonninNotesInputModal()
    }

    const isOther = computed(() => {
      return authStore.user?.user_id !== kinmuListInfo.value.userId
    })

    // 打刻詳細ダイアログの表示
    const openDakokuDetailDialog = async (kinmu: DakokuDataFull, datetime: string, shinseis: DakokuInfoShinsei | null = null) => {
      if (!kinmu) {
        return;
      }
      console.log(datetime)
      await dakokuDetailModal.setData(kinmu, datetime);
      await dakokuDetailModal.setShinseis(shinseis)
      dakokuDetailModal.openDakokuDetailModal();
    };

    // 打刻詳細ダイアログのクローズ
    const closeDakokuDetailDialog = () => {
      dakokuDetailModal.closeDakokuDetailModal();
    };

    const setEnableTimeSheetKakuteiStatus = async () => {
      if (kinmuListInfo.value.dakokuSyouninGroupId) {
        const isSyounin = await isSyouninUser(kinmuListInfo.value.dakokuSyouninGroupId, authStore.user?.user_id)
        const isKakunin = await isKakuninUser(kinmuListInfo.value.dakokuSyouninGroupId, authStore.user?.user_id)

        if (isSyounin || isKakunin) {
          if (authStore.hasPermission(PermissionConst.TIME_SHEET_KAKUTEI)) {
            // 承認者または確認者、かつ権限「月次勤怠の確定／解除」を持つ場合はタイムシート確定を可能とする（MEDICA_AS-1254）
            // 課題では「派遣先上長は」とあるが、設計思想としてロールによる制御は行わないことや限定しないことによる不都合は無いものと考えこの条件としている
            isTimeSheetKakuteiUser.value = true
          } else {
            // 承認者であっても権限がない場合は不許可
            isTimeSheetKakuteiUser.value = false;
          }
        } else {
          isTimeSheetKakuteiUser.value = false;
        }
      }
    }

    const toStaffList = (async () => {
      await myTaskCommonStore.setTargetId(null) // 自動スクロール対象外なので対象IDを月次勤怠の確定／解除nullにする
      await myTaskCommonStore.setTab('kintai-check-staff-list')
      router.push(
        { name: RouterConst.MY_TASK }
      );
    });

    const toSoumuCheck = (async () => {
      await myTaskCommonStore.setTab('soumu-dakoku-check')
      router.push(
        { name: RouterConst.MY_TASK, params: { from: RouterConst.HAKEN_KINMU_LIST } }
      );
    });

    const toHakensakiShimeCheck = (async () => {
      await myTaskCommonStore.setTab('hakensaki-shime-check-list')
      router.push(
        { name: RouterConst.MY_TASK, params: { from: RouterConst.HAKEN_KINMU_LIST } }
      );
    });

    const toTimeSheetKakuteiShime = (async () => {
      await myTaskCommonStore.setTargetId(null) // 自動スクロール対象外なので対象IDをnullにする
      await myTaskCommonStore.setTab('time-sheet-kakutei-shime')
      router.push(
        { name: RouterConst.MY_TASK, params: { from: RouterConst.HAKEN_KINMU_LIST } }
      );
    });

    // 総務修正ダイアログの表示
    const openSoumuSyuuseiDialog = async (kinmu: DakokuDataFull | null, datetime: string, shinseis: DakokuInfoShinsei | null) => {
      if (!kinmuListInfo.value.userId) {
        DialogService.error({ text: '対象ユーザーIDの取得に失敗しました' })
        return
      }

      if (!kintaiSummaryIsClosed) {
        await DialogService.error({ html: 'このタイムシートはすでに締められています。<br>続行したい場合は月締めを解除してください。' })
        return
      }

      await soumuSyuuseiModal.setData(kinmu, datetime, kinmuListInfo.value.userId, shinseis);
      soumuSyuuseiModal.openSoumuSyuuseilModal();
    };

    // 総務修正ダイアログのクローズ
    const closeSoumuSyuuseiDialog = () => {
      soumuSyuuseiModal.closeSoumuSyuuseilModal();
    };

    // 総務修正ダイアログの実行
    const sendSoumuSyuuseiDialog = async (result: boolean) => {

      if (result) {
        await DialogService.info({
          html: "処理に成功しました。再読込します。"
        })
      }
      soumuSyuuseiModal.closeSoumuSyuuseilModal()
      await soumuSyuuseiModal.clearData()
      await allLoad()
    }

    // 集計処理
    const calcProc = async () => {
      await calcForEach();

      // 総務修正分の縦計を計算
      await calcAllSoumuModifyTime();
    };

    // 個々の総務編集を集計
    const calcForEach = async () => {
      if (!kinmuListData.value) {
        return
      }

      for (let i = 0; i < kinmuListData.value.list.length - 1; i++) {
        calcItem(i);
      }
    };

    // 総務の入力を受けて、派遣先用の勤務時間を計算する
    const calcItem = (idx: number) => {
      if (!kinmuListData.value) {
        return
      }

      const soumuNote2HourStr = kinmuListData.value.list[idx].kinmus[0].soumu_note2
      if (!soumuNote2HourStr || typeof soumuNote2HourStr === 'undefined') {
        return;
      }

      const soumuNote2Hour = cloneDeep(parseFloat(soumuNote2HourStr))
      if (soumuNote2Hour >= 24) {
        DialogService.error({
          text: '24時間より小さい値を入力して下さい。'
        }, true);
        return;
      }

      let workTimeStr = "1970/1/1 00:00:00";
      let syoteiWorkTimeStr = kinmuListData.value.list[idx].kinmus[0].syotei_work_times;

      if (syoteiWorkTimeStr != null) {
        workTimeStr = "1970/1/1 " + syoteiWorkTimeStr;
      }

      let workTime = new Date(workTimeStr).getTime();

      // let soumuNote2HourStr = kinmuList.value[idx].kinmus[0].soumu_note2;
      let addHour = 0;
      if (soumuNote2Hour) {
        addHour = 60 * 60 * 1000 * soumuNote2Hour;
      } else {
        kinmuListData.value.list[idx].kinmus[0].soumu_note2 = "00:00"
      }

      let tmpWorkTimeStr = dayjs(workTimeStr).format('HH:mm');
      let tmpWorkTime = tmpWorkTimeStr.split(":");
      let tmpWorkHour = parseInt(tmpWorkTime[0], 10) * 60 * 60 * 1000 + parseInt(tmpWorkTime[1], 10) * 60 * 1000;

      let modifyTimeStr = "00:00";

      if ((addHour < 0) && ((tmpWorkHour + addHour) < 0)) {
        modifyTimeStr = "00:00";
      } else {
        let modifiTime = new Date(workTime + addHour);
        modifyTimeStr = dayjs(modifiTime).format('HH:mm');
      }

      kinmuListData.value.list[idx].kinmus[0].modifiedKinmuTimes = modifyTimeStr;

    };

    // 総務修正分の縦計値
    const allSoumuModifyTime = ref(0);

    // 総務修正分の縦計を計算
    const calcAllSoumuModifyTime = async () => {
      if (!kinmuListData.value) {
        return
      }

      let modifyTime = 0;
      kinmuListData.value.list.forEach(function (value) {
        value.kinmus.forEach(function (val) {

          let soumuNote2Str = val.soumu_note2;

          if (soumuNote2Str === undefined) {
            return;
          }

          if (typeof soumuNote2Str !== 'undefined' && soumuNote2Str !== "" && soumuNote2Str) {
            modifyTime += parseFloat(soumuNote2Str);

          }
        });
      });

      allSoumuModifyTime.value = modifyTime;
    }

    // 承認チェックボックスが使用可能かどうか
    const isEnableCheckBox = (kinmu: DakokuDataFull) => {
      // 承認待ち、かつ、入力が完了している場合のみ
      return kinmu.syounin_status_type == OptionConst.DAKOKU_SYOUNIN_STATUS.WAIT && !kinmu.isUncomplete
    }

    const recalcAll = async () => {
      const dialogResult = await DialogService.question({
        text: Message.CONFIRM_RECALC_DAKOKU_ALL,
        confirmButtonText: 'はい',
        showCancelButton: true,
        cancelButtonText: 'いいえ',
      })

      if (!dialogResult.isConfirmed) {
        return
      }
      if (kinmuListData.value === null || kinmuListData.value.userId === null ||selectedSyuugyouBasyoOption.value === null) {
        await DialogService.error({
          title: '',
          html: Message.NO_INFO_ERROR_RECALC_DAKOKU,
        })
        return
      }

      try {
        for (const kinmuData of kinmuListData.value.list) {
          const kinmu = kinmuData.kinmus[0];
          if (kinmu == null || kinmu.dakoku_id == null) {
            continue;
          }
          if (kinmu.koyou_keiyaku_id) {
            DialogService.nowloading(DateUtil.format(kinmuData.datetime)  + 'の計算をしています・・・')
            const req: RecalcDakokByDakokuInfo[] = [{
              userId: kinmuListData.value.userId,
              syuugyouBasyoId: selectedSyuugyouBasyoOption.value.val,
              koyouKeiyakuId: kinmu.koyou_keiyaku_id,
              date: kinmuData.datetime instanceof Date ? kinmuData.datetime.toDateString() : kinmuData.datetime,
            }]
            await recalcDakokuByDakokuInfos(req, false)
          } else {
            continue
          }

        }
      } catch (e) {
        console.error(e);
      } finally {
        DialogService.close()
        await allLoad()
      }
    }

    // 一括承認にチェックをすべて入れる
    const setDakokuSyouninAll = () => {
      if (!kinmuListData.value) {
        return
      }

      kinmuListData.value.list.forEach(item => {
        if (dayjs(item.datetime).isSameOrAfter(dayjs(), 'date')) {
          // 当日以降はチェックを付けない
          return
        }
        if (item.kinmus.length == 0) {
          // 入力が無い場合はチェックを付けない
          return
        }
        for (let i = 0; i < item.kinmus.length; i++) {
          if (!isEnableCheckBox(item.kinmus[i])) {
            return
          }
        }
        item.is_syounin_select = true
      })
    };

    // 打刻承認を一括登録します。
    const updateDakokuSyouninList = async () => {
      if (!kinmuListData.value) {
        return
      }

      const dialogResult = await DialogService.question({
        text: '承認チェックを一括登録しますか？',
        showCancelButton: true,
        confirmButtonText: '登録します',
        cancelButtonText: 'キャンセル',
      })

      if (!dialogResult.isConfirmed) {
        return
      }

      await reloadShinseiData()

      let params = [];
      const selectItems = kinmuListData.value.list.filter((v: any) => v.is_syounin_select)
      for (let i = 0; i < selectItems.length; i++) {
        if (selectItems[i].waitShinseis.length > 0) {
          const waitingShinsei = ConvertUtil.getShinseiLabel(selectItems[i].waitShinseis)
          await DialogService.warning({
            title: '未承認の申請があります',
            text: waitingShinsei + 'の承認を先に行ってください',
          }, true)
          return
        }
        for (let j = 0; j < selectItems[i].kinmus.length; j++) {
          params.push(selectItems[i].kinmus[j].dakoku_id)
        }
      }

      await ikkatsuSyounin(params)
      allLoad()
    };

    // 申請データを再読込
    const reloadShinseiData = async (refDakokuId: number | null = null) => {
      if (!kinmuListData.value) {
        return
      }
      if (!selectedSyuugyouBasyoOption.value || !kinmuListInfo.value.userId) {
        return
      }

      const latestListData = await getKinmuList(kinmuListInfo.value.year, kinmuListInfo.value.month, selectedSyuugyouBasyoOption.value.val, selectedSyuugyouBasyoOption.value.koyou_id, kinmuListInfo.value.userId, refDakokuId)
      if (!latestListData) {
        return
      }

      for (let i = 0; i < kinmuListData.value.list.length; i++) {
        const currentItem = kinmuListData.value.list[i]
        const latestItem = latestListData.list.find((v: any) => v.key == currentItem.key)
        if (latestItem) {
          currentItem.shinseis = latestItem.shinseis
          currentItem.waitShinseis = latestItem.waitShinseis
        }
      }
    };

    // フィルタ変数
    const filter = ref('');

    // 承認の選択をした打刻レコードの行数を返す
    const selectItemCountSyounin = computed(() => {

      if (!kinmuListSelectSyouninData) {
        return
      }

      let selectItemsSyounin = [];

      for (let i = 0; i < kinmuListSelectSyouninData.value.length; i++) {

        const selectItems = kinmuListSelectSyouninData.value.filter((v: any) => v.is_syounin_select);
        if (selectItems.length < 1) {
          continue
        }

        selectItemsSyounin.push(selectItems);
      }

      let count = 0;
      if (selectItemsSyounin.length > 0) {
        for (let j = 0; j < selectItemsSyounin.length; j++) {
          count += selectItemsSyounin[j].length;
        }
      }

      return count;
    });

    const recalcByInfo = async (item: KinmuListData) => {
      const dialogResult = await DialogService.question({
        text: Message.CONFIRM_RECALC_DAKOKU,
        confirmButtonText: 'はい',
        showCancelButton: true,
        cancelButtonText: 'いいえ',
      })

      if (!dialogResult.isConfirmed) {
        return
      }

      if (kinmuListInfo === null || selectedSyuugyouBasyoOption.value === null) {
        await DialogService.error({
          title: '',
          html: Message.NO_INFO_ERROR_RECALC_DAKOKU,
        })
        return
      }

      if (kinmuListInfo.value.userId === null || kinmuListInfo.value.syuugyouBasyo === null) {
        await DialogService.error({
          title: '',
          html: Message.NO_INFO_ERROR_RECALC_DAKOKU,
        })
        return
      }

      //　本来であればkinmuListInfo.value.syuugyouBasyo.koyou_idで雇用契約IDが取れるはずなんだけど
      // undefinedになっている場合があるためselectedSyuugyouBasyoOptionから取得（24.1.1 大塚）
      const req: RecalcDakokByDakokuInfo[] = [{
        userId: kinmuListInfo.value.userId,
        syuugyouBasyoId: kinmuListInfo.value.syuugyouBasyo.val,
        koyouKeiyakuId: selectedSyuugyouBasyoOption.value.koyou_id,
        date: item.datetime instanceof Date ? item.datetime.toDateString() : item.datetime
      }]

      await recalcDakokuByDakokuInfos(req, true)
      await allLoad()
    }

    return {
      Config,
      kinmuListData,
      isLoading,
      getByPeriod,
      dateFormat,
      dateFormatJp,
      timeFormat,
      changeMonth,
      dakokuSyuuseiModalRef: dakokuSyuuseiModal.dakokuSyuuseiModalRef,
      dakokuSyouninModalRef: dakokuSyouninModal.dakokuSyouninModalRef,
      dakokuDetailModalRef: dakokuDetailModal.dakokuDetailModalRef,
      openDakokuSyuuseiDialog,
      canceldDakokuSyuusei,
      openDakokuSyouninDialog,
      dakokuSyuuseiModalParts: dakokuSyuuseiModal.dakokuSyuuseiModalParts,
      dakokuSyouninModalParts: dakokuSyouninModal.dakokuSyouninModalParts,
      dakokuDetailModalParts: dakokuDetailModal.dakokuDetailModalParts,
      sendDakokuSyuusei,
      sendDakokuSyounin,
      canceldDakokuSyounin,
      shinseis: dakokuDetailModal.shinseis,
      hayabanOsobanData: dakokuSyuuseiModal.hayabanOsoban,
      syuuseiData: dakokuSyuuseiModal.syuuseiData,
      shinseiData: dakokuSyuuseiModal.shinseiData,
      syouninData: dakokuSyouninModal.syouninData,
      detailData: dakokuDetailModal.detailData,
      OptionConst,
      syuugyouBasyoOptions,
      selectedSyuugyouBasyoOption,
      yearMonthForMonthPicker,
      changeSyuugyouBasyo,
      authStore,
      PermissionConst,
      RouterConst,
      dakokuSyouninStatus,
      setKintaiSummaryId,
      kintaiSummaryId,
      kintaiSummaryIsClosed,
      switchCloseKintaiSummary,
      reloadSummary,
      openHonninNotesModal,
      honninNotesInputModal,
      honninNotesInputModalRef: honninNotesInputModal.honninNotesInputModalRef,
      honninNotesInputModalParts: honninNotesInputModal.honninNotesInputModalParts,
      honninNotesInputSend,
      honninNotesInputCancel,
      selectedDakokuData,
      isInit,
      isOther,
      timeToHHmm,
      openDakokuDetailDialog,
      closeDakokuDetailDialog,
      kinmuListInfo,
      Const,
      allLoad,
      rows,
      toStaffList,
      selectedDakoku,
      toSoumuCheck,
      soumuSyuuseiModalRef: soumuSyuuseiModal.soumuSyuuseiModalRef,
      soumuSyuuseiModalParts: soumuSyuuseiModal.soumuSyuuseiModalParts,
      soumuSyuuseiData: soumuSyuuseiModal.syuuseiData,
      openSoumuSyuuseiDialog,
      closeSoumuSyuuseiDialog,
      sendSoumuSyuuseiDialog,
      isAllowDakokuSyounin,
      sumKinmuTime,
      allSoumuModifyTime,
      isEnableCheckBox,
      recalcAll,
      setDakokuSyouninAll,
      isAllowIkkatsuSyounin,
      canSyounin,
      updateDakokuSyouninList,
      kintaiSummary,
      toTimeSheetKakuteiShime,
      toHakensakiShimeCheck,
      kinmuListSelectSyouninData,
      filter,
      selectItemCountSyounin,
      recalcByInfo,
      isTimeSheetKakuteiUser
    };
  },
  components: {
    'dialog-dakoku-syuusei': DakokuSyuusei,
    'dialog-dakoku-syounin': DakokuSyounin,
    'dialog-dakoku-detail': DakokuDetail,
    'kinmu-summary': KinmuSummary,
    'honnin-notes-input': HonninNotesInput,
    'shinseis-title': ShinseisTitle,
    'soumu-syuusei': SoumuSyuusei,
  }
});
</script>

<style lang="scss" scoped>
@import '@scss/components/kinmu-list.scss';
</style>
